import { useEffect } from 'react';
import { getAccessToken } from '@/shared/auth/jwt-storage';
import { loadCrmProfile, refreshCrmProfileSession } from '@/shared/auth/auth.reducer';
import { useAppDispatch, useAppSelector } from '@/store';
/**
 * Ensure CRM profile is loaded when a feature needs it (e.g. agent statistics dialog).
 * On page refresh, `hydrateSession` loads profile once — this hook does not duplicate that.
 */
export function useCrmProfile(enabled = true) {
    const dispatch = useAppDispatch();
    const { session, hydrating, crmProfile, crmProfileLoading, crmProfileLoaded } = useAppSelector((s) => s.auth);
    const hasToken = typeof window !== 'undefined' && Boolean(getAccessToken());
    const authenticated = Boolean(session || hasToken);
    useEffect(() => {
        if (!enabled || !authenticated || hydrating || crmProfileLoaded || crmProfileLoading)
            return;
        void dispatch(loadCrmProfile());
    }, [dispatch, enabled, authenticated, hydrating, crmProfileLoaded, crmProfileLoading]);
    useEffect(() => {
        if (!enabled || !authenticated)
            return;
        const onPageShow = (event) => {
            if (!event.persisted || hydrating)
                return;
            void dispatch(refreshCrmProfileSession());
        };
        window.addEventListener('pageshow', onPageShow);
        return () => window.removeEventListener('pageshow', onPageShow);
    }, [dispatch, enabled, authenticated, hydrating]);
    return { crmProfile, loading: crmProfileLoading };
}
